export const ASYNC_FETCH = 'Landing_page/ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESS_LANDINGPAGE = 'Landing_page/ASYNC_FETCH_SUCCESS_LANDINGPAGE';
export const ASYNC_FETCH_FAILURE = 'Landing_page/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_USAGE = 'Landing_page/ASYNC_FETCH_USAGE';
export const ASYNC_FETCH_SUCCESS_USAGE = 'Landing_page/ASYNC_FETCH_SUCCESS_USAGE';
export const ASYNC_FETCH_FAILURE_USAGE = 'Landing_page/ASYNC_FETCH_FAILURE_USAGE';
export const SET_PLAN_DETAILS = 'Landing_page/SET_PLAN_DETAILS';
export const ASYNC_FETCH_CHARGES = 'Landing_page/ASYNC_FETCH_CHARGES';
export const ASYNC_FETCH_SUCCESS_CHARGES = 'Landing_page/ASYNC_FETCH_SUCCESS_CHARGES';
export const ASYNC_FETCH_FAILURE_CHARGES = 'Landing_page/ASYNC_FETCH_FAILURE_CHARGES';
export const ASYNC_FETCH_ALERT_SETTINGS = 'Landing_page/ASYNC_FETCH_ALERT_SETTINGS';
export const ASYNC_FETCH_SUCCESS_ALERT_SETTINGS = 'Landing_page/ASYNC_FETCH_SUCCESS_ALERT_SETTINGS';
export const ASYNC_FETCH_FAILURE_ALERT_SETTINGS = 'Landing_page/ASYNC_FETCH_FAILURE_ALERT_SETTINGS';
export const UUPlanIds = ["69183","69185"];
export const intl_monthly =["1948","1949"];
export const intl_travel = ["1327","1329"];
export const intl_travel_20 = ["1645"];
export const intl_travel_100_talk = ["444","445"];
export const intl_travel_100_data = ["431","412"];
export const mexico_100_talk = ["434","441"];
export const mexico_500_talk = ["442","443"];